import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ControlText, ControlTextArea, ControlSelect2 } from "../../helpers";
import { ControlSmallWrapper } from "../../helpers/ControlSmallWrapper";
import { AbmForm } from "../AbmForm";


export const Form = ({item, schema, onCancel, onConfirm, confirmLabel = "Guardar", cancelLabel = "Cancelar", title, errorState, data = {}}) => {

  return (
    <AbmForm title={title} actionsTop={false} actionsBottom={true} onSubmit={onConfirm} schema={schema} item={item} onCancel={onCancel} confirmLabel={confirmLabel} cancelLabel={cancelLabel} errorState={errorState}>
      {({onControlChange, entity, entityErrors}) => (
        <>
          <Grid item xs={12}>
            <ControlText name="nombre" label="Nombre" autoFocus errors={entityErrors} data={entity} onChange={onControlChange} Wrapper={ControlSmallWrapper} errorPlacement="bottom"/>
          </Grid>  
          <Grid item xs={12}>
            <ControlTextArea name="descripcion" label="Descripcion" errors={entityErrors} data={entity} onChange={onControlChange} Wrapper={ControlSmallWrapper} errorPlacement="bottom"/>
          </Grid>  
          <Grid item xs={12}>
            <ControlSelect2 name="id_centro" label="Centro" errors={entityErrors} data={entity} onChange={onControlChange} options={data.centros || []} isMulti={false} closeMenuOnSelect={true}  Wrapper={ControlSmallWrapper}/>
          </Grid>  
          <Grid item xs={12}>
            <ControlSelect2 name="id_planeamiento" label="Planeamiento" errors={entityErrors} data={entity} onChange={onControlChange} options={data?.planeamientos?.filter(p => !p.cerrado) || []} isMulti={false} closeMenuOnSelect={true}  Wrapper={ControlSmallWrapper}/>
          </Grid>
        </>
      )}
    </AbmForm>
  );
}